import ProjectContainer from "../containers/ProjectsContainer";

const PortfolioPage = () => {
    return (
        <div className="bg-primary py-[150px]">
            <ProjectContainer/>
        </div>
    );
}

export default PortfolioPage;